"use client";
export { FormInlineLabel as default } from "../../../_Builtin/Form";
